import React from 'react'
import { Grid, Row, Col, Button, Modal } from 'react-bootstrap'

export class ProcessingModal extends React.Component {
  render () {
    return (
      <Modal show={this.props.show} bsSize='large'>
        <Modal.Body>
          <div className='main-title'>Processing...</div>
          <div className='modal-message'>
            <div className='payment-gif' />
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export class FailModal extends React.Component {
  render () {
    return (
      <Modal show={this.props.show} bsSize='large'>
        <Modal.Body>
          <div className='main-title'>Sorry...</div>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={8} smOffset={2} className='modal-message centered'>
                Your donation can't be processed right now.<br />
                Try again later.
              </Col>
            </Row>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

